import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import styled from 'styled-components'
const drawerWidth = 520

export const OutputsContainer = styled.div`
  margin-bottom: 20px;
  padding: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`

export const AddOutputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 16px;

  .MuiIconButton-root {
    background-color: #f06292;
    color: white;
    border-radius: 8px;
    padding: 8px;

    &:hover {
      background-color: #e91e63;
      box-shadow: 0 2px 8px rgba(240, 98, 146, 0.3);
    }

    &:disabled {
      background-color: rgba(0, 0, 0, 0.12);
      color: rgba(0, 0, 0, 0.26);
    }
  }
`

export const ChoicesContainer = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: start;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`

export const ChoicesIndexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  .MuiTypography-subtitle2 {
    font-weight: 600;
    color: #f06292;
    font-size: 14px;
  }

  .MuiIconButton-root {
    color: #f44336;
    padding: 6px;

    &:hover {
      background-color: rgba(244, 67, 54, 0.04);
    }

    &:disabled {
      color: rgba(0, 0, 0, 0.26);
    }
  }
`

export const ChoicesTitleContainer = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`

export const ChoicesTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
  margin-bottom: 8px;

  .MuiTypography-root {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.7);
    font-size: 14px;
  }

  .MuiFormControlLabel-root {
    margin: 0;

    .MuiTypography-body1 {
      font-size: 13px;
      color: rgba(0, 0, 0, 0.6);
    }
  }
`

export const SimilarityContainer = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  align-items: start;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px;
  background-color: #fafafa;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
`

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      position: 'absolute',
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginTop: '5.5rem',
      borderRadius: '8px 0 0 8px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#ffffff',

      '&.MuiDrawer-paperAnchorDockedRight': {
        height: `calc(100% - 6rem)`,
        zIndex: '5',
        borderLeft: `1px solid ${theme.palette.divider}`,
      },
    },

    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(2, 3),
      position: 'fixed',
      background: '#fafafa',
      width: `${drawerWidth - 1}px`,
      zIndex: 999,
      borderBottom: `1px solid ${theme.palette.divider}`,
      borderRadius: '8px 0 0 0',
      minHeight: '72px',

      '& .MuiButton-root': {
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 500,
        padding: theme.spacing(1, 2),
        boxShadow: 'none',
        '&:hover': {
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        },
      },

      '& .MuiIconButton-root': {
        color: '#9e9e9e',
        padding: theme.spacing(1),
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
          color: 'rgba(0, 0, 0, 0.7)',
        },
      },
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    tabs: {
      marginTop: '88px',
      borderBottom: `1px solid ${theme.palette.divider}`,
      backgroundColor: '#ffffff',

      '& .MuiTab-root': {
        textTransform: 'none',
        fontWeight: 500,
        fontSize: '14px',
        minHeight: '48px',
        color: 'rgba(0, 0, 0, 0.7)',
        '&.Mui-selected': {
          color: '#F06292',
          fontWeight: 600,
        },
      },

      '& .MuiTabs-indicator': {
        backgroundColor: '#F06292',
        height: '3px',
        borderRadius: '3px 3px 0 0',
      },
    },
    drawerContent: {
      padding: theme.spacing(2, 3, 1),
      backgroundColor: '#ffffff',
      height: '100%',
      overflowY: 'auto',

      '& .MuiTextField-root': {
        marginBottom: theme.spacing(1.5),
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          backgroundColor: '#ffffff',
          '& fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.12)',
          },
          '&:hover fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.25)',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#F06292',
            borderWidth: '2px',
          },
        },
      },

      '& .MuiFormControl-root': {
        marginBottom: theme.spacing(1.5),
      },

      '& .MuiTypography-h6': {
        fontWeight: 600,
        color: 'rgba(0, 0, 0, 0.87)',
        marginBottom: theme.spacing(1),
      },

      '& .MuiTypography-subtitle2': {
        fontWeight: 500,
        color: 'rgba(0, 0, 0, 0.7)',
        marginBottom: theme.spacing(1),
      },
    },
    sectionContainer: {
      backgroundColor: '#fafafa',
      borderRadius: '8px',
      padding: theme.spacing(2, 2, 1.5),
      marginBottom: theme.spacing(1.5),
      border: `1px solid ${theme.palette.divider}`,
    },
    fieldGroup: {
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      padding: theme.spacing(1.5, 2, 1.5),
      marginBottom: theme.spacing(1.5),
      border: `1px solid rgba(0, 0, 0, 0.12)`,
    },
  }),
)
